import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=4406e9da&scoped=true"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=4406e9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406e9da",
  null
  
)

export default component.exports